import { JSMOverlayTemplate } from '@/components/signup/layouts/product-overlay-template';
import { ReturnToProduct } from '@/components/signup/site-activation/components/common/return-to-product';
import { SiteActivation } from '@/components/signup/site-activation/site-activation';

import { Headings } from '../components/headings';
import { PickUpWhereYouLeftOffText } from '../components/sub-heading';
import { WelcomeBackText } from '../components/welcome-back-heading';

const CurrentProductUserContent = () => {
	return (
		<>
			<Headings main={<WelcomeBackText />} sub={<PickUpWhereYouLeftOffText />} />
			{/* everyone with a service collection should see a return to product experience */}
			<SiteActivation CurrentProductUser={<ReturnToProduct />} />
		</>
	);
};

export const CurrentProductUser = () => (
	<JSMOverlayTemplate size="sm">
		<CurrentProductUserContent />
	</JSMOverlayTemplate>
);
